export default __webpack_public_path__ + "static/cottee-parker-logo-a309562abad7bd6859b1a3e1e0a70c56.png";